import PropTypes from 'prop-types'
import React from 'react'

import Cont from '../../../external/components/layout/Cont'
import Section, { MAIN } from '../../../external/components/layout/Section'
import ABaseLink from '../../../external/components/link/ABaseLink'
import { createSimpleLinkProps } from '../../../external/components/link/LinkUtils'
import TextHoverable from '../../../external/components/link/TextHoverable'
import HTag, { HEADER_TYPES } from '../../../external/components/text/HTag'
import TextBlock from '../../../external/components/text/TextBlock'
import { isEmpty, isUndefined } from '../../../external/utilities/GeneralUtils'
import { ROLES } from '../../../external/utilities/accessibility/Definitions'

const SimpleDescriptionCard = ({
  title,
  description,
  linkURL,
  linkInternal = true,
  linkNewWin = false,
  imageURL = '',
  imageLabel = '',
  hTagType = null,
}) => {
  const getImageStyle = function () {
    if (!isEmpty(imageURL)) {
      return { backgroundImage: `url(${imageURL})` }
    }

    return null
  }

  const getImageUI = function () {
    if (!isEmpty(imageURL)) {
      return (
        <ABaseLink
          {...createSimpleLinkProps(linkURL, linkInternal, linkNewWin)}
          tabIndex={-1}
        >
          <div
            className="simple-description-card__image"
            style={getImageStyle()}
          >
            <Cont
              asSpan
              cmpSRonly
              cmpRole={ROLES.DOC_STRUCTURE.IMG}
              cmpLabel={imageLabel}
            >
              {imageLabel}
            </Cont>
          </div>
        </ABaseLink>
      )
    }

    return null
  }

  const getHeaderUI = function () {
    const titleUI = (
      <TextHoverable
        selected
        fontSizeType={3}
        fontFamily={'Georgia'}
        fontColor={'blue-dark'}
        {...createSimpleLinkProps(linkURL, linkInternal, linkNewWin)}
      >
        {title}
      </TextHoverable>
    )

    if (!isEmpty(hTagType)) {
      return <HTag type={hTagType}>{titleUI}</HTag>
    }

    return titleUI
  }

  const getDescriptionUI = function () {
    if (isUndefined(description) || isEmpty(description)) {
      return null
    }

    return (
      <Cont className="simple-description-card__description">
        <TextBlock isHTML isDefaultHTMLStyle content={description} />
      </Cont>
    )
  }

  const getMainUI = function () {
    if (!isEmpty(title)) {
      return (
        <div className={'simple-description-card__container'}>
          {getImageUI()}
          <Section />
          <Cont className={''}>{getHeaderUI()}</Cont>
          <Section />
          {getDescriptionUI()}
        </div>
      )
    }

    return <div />
  }

  return <Section style={MAIN}>{getMainUI()}</Section>
}

SimpleDescriptionCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  linkURL: PropTypes.string.isRequired,
  linkInternal: PropTypes.bool,
  linkNewWin: PropTypes.bool,
  imageURL: PropTypes.string,
  imageLabel: PropTypes.string,
  hTagType: PropTypes.oneOf(HEADER_TYPES),
}

export default SimpleDescriptionCard
